export const ControlRequestTypeEnum = {
    SendControlRequest: 'sendControlRequest',
    GiveControl:'giveControl',
    Reject: 'reject',
    GetControlRequest:'getControlRequest'
}